"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProjectFontConfigurationSchema = exports.BrowserFontSchema = exports.ProjectFontSchema = void 0;
const zod_1 = require("zod");
const Fonts_1 = require("./Fonts");
const TextAttr_1 = require("./DrawingModels/TextAttr");
exports.ProjectFontSchema = Fonts_1.IFontRenderSettingsSchema.extend({
    type: zod_1.default.literal('project'),
    name: zod_1.default.string(),
    glyphs: zod_1.default.record(zod_1.default.coerce.number(), zod_1.default.string().array()),
});
exports.BrowserFontSchema = zod_1.default.object({
    type: zod_1.default.literal('browser'),
    name: zod_1.default.string(),
    attrs: TextAttr_1.TextAttrSchema.array().optional(),
    thickness: zod_1.default.number().optional(),
    size: zod_1.default.number().optional(),
    rasterSizeCorrection: zod_1.default.number().optional(),
});
exports.ProjectFontConfigurationSchema = zod_1.default.object({
    fonts: zod_1.default.record(zod_1.default.string(), zod_1.default.preprocess((val) => {
        if (typeof val === 'object' && val !== null && !('type' in val)) {
            return { ...val, type: 'project' };
        }
        return val;
    }, zod_1.default.discriminatedUnion('type', [exports.ProjectFontSchema, exports.BrowserFontSchema]))),
});
//# sourceMappingURL=ProjectFontConfiguration.js.map